export default function PHP_getrandmax() {
  return (
    <div>
      <h1>PHP_getrandmax</h1>
    </div>
  );
}
